(ns practitest.frontend.oauth-authorization.views
  (:require
   [practitest.frontend.login.views :refer [left-panel]]
   [practitest.frontend.common.i18n :refer [get-translation]]
   [practitest.frontend.components.selector2 :refer [new-select]]
   [re-frame.core :as re-frame]
   [reagent.core :as reagent]))

(re-frame/reg-sub
  ::oauth-data
  (fn [db _]
    (get-in db [:options :oauth-data])))

(defn- csrf-token []
  (some-> js/document
          (.querySelector "meta[name='csrf-token']")
          (.getAttribute "content")))

(defn- oauth-form [method params button]
  [:form {:method "post" :action "/oauth/authorize"}
   (when (= method :delete)
     [:input {:type "hidden" :name "_method" :value "delete"}])
   [:input {:type "hidden" :name "authenticity_token" :value (csrf-token)}]
   (for [[k v] params]
     (when v
       [:input {:type "hidden" :name (name k) :value v :key (name k)}]))
   button])

(defn oauth-authorization-page [_route]
  (let [oauth-data       (re-frame/subscribe [::oauth-data])
        selected-account (reagent/atom nil)]
    (fn [_route]
      (let [{:keys [client_name accounts oauth_params]} @oauth-data
            account            (or @selected-account (first accounts))
            multiple-accounts? (> (count accounts) 1)]
        [:div.login-page
         [left-panel]
         [:div.right
          [:div.right-inner
           [:div.form-title
            client_name " " (get-translation "oauth.wants-access" "wants to access your PractiTest account")]
           [:p.oauth-description
            (get-translation "oauth.description-prefix" "By approving this request") ", "
            client_name " "
            (get-translation "oauth.description-suffix" "will be able to access your projects, tests, and other data on your behalf.")]
           (when multiple-accounts?
             [:div.oauth-account-selector
              [new-select {:items     accounts
                           :value     account
                           :label-fn  :name
                           :key-fn    :id
                           :on-change #(reset! selected-account %)}]])
           [:div.oauth-actions
            [oauth-form :delete oauth_params
             [:button.oauth-btn-cancel
              (get-translation "oauth.deny" "Deny")]]
            [oauth-form :post (assoc oauth_params :account_id (:id account))
             [:button.oauth-btn-allow
              (get-translation "oauth.allow" "Allow")]]]]]]))))
